import axios from './configObra/config-obra'

const defaultRoute = '/obras'
const torreRoute = '/torres'
const andaresRoute = '/andares'
const apartamentoRoute = '/apartamentos'

export default {
  list: (filial, filialId) => axios.get(`${defaultRoute}?${filial}=${filialId}`),
  listId: (id) => axios.get(`${defaultRoute}/${id}`),
  create: (obra) => axios.post(defaultRoute, obra),
  update: (id, obra) => axios.put(`${defaultRoute}/${id}`, obra),
  remove: (id) => axios.delete(`${defaultRoute}/${id}`),
  // Adiciona Torre
  createTorres: (obraId, torre) =>
    axios.post(`${defaultRoute}${torreRoute}/${obraId}`, torre),

  deleteTorre: (obraId, torreId) =>
    axios.delete(`${defaultRoute}${torreRoute}/${obraId}/${torreId}`),

  updataTorre: (obraId, torreId ,torre) =>
    axios.patch(`${defaultRoute}${torreRoute}/${obraId}/${torreId}`,torre),
  // Andar
  createAndares: (obraId, andares) =>
    axios.post(`${defaultRoute}${andaresRoute}/${obraId}`, andares),

  deleteAndar: (obraId, andarId) =>
    axios.delete(`${defaultRoute}${andaresRoute}/${obraId}/${andarId}`),
  
  updataAndar: (obraId, andarId, andar) =>
    axios.patch(`${defaultRoute}${andaresRoute}/${obraId}/${andarId}`, andar),
  // apartamento
  createApartamento: (obraId, apartamento) =>
    axios.post(`${defaultRoute}${apartamentoRoute}/${obraId}`, apartamento),

  deleteApartamento: (obraId, apartamentoId) =>
    axios.delete(
      `${defaultRoute}${apartamentoRoute}/${obraId}/${apartamentoId}`
    ),
  updataApartamento: (obraId, apartamentoId , apartamento) =>
    axios.patch(
      `${defaultRoute}${apartamentoRoute}/${obraId}/${apartamentoId}`, apartamento
    ),
}
